// @ts-nocheck
import * as __GraphQLSchemaTypes from "./graphql";

import { GraphQLClient } from "graphql-request";
import { RequestInit } from "graphql-request/dist/types.dom";
import {
  useMutation,
  useQuery,
  UseMutationOptions,
  UseQueryOptions,
} from "react-query";

function fetcher<TData, TVariables extends { [key: string]: any }>(
  client: GraphQLClient,
  query: string,
  variables?: TVariables,
  requestHeaders?: RequestInit["headers"],
) {
  return async (): Promise<TData> =>
    client.request({
      document: query,
      variables,
      requestHeaders,
    });
}
export type ChangeFeedLocationMutationVariables = __GraphQLSchemaTypes.Exact<{
  feedId: __GraphQLSchemaTypes.Scalars["ID"]["input"];
  googlePlaceId: __GraphQLSchemaTypes.Scalars["String"]["input"];
}>;

export type ChangeFeedLocationMutation = {
  __typename?: "Mutation";
  changeFeedLocation: {
    __typename?: "FeedBase";
    id: string;
    feedType: __GraphQLSchemaTypes.FeedType;
  };
};

export type CreateFeedMutationVariables = __GraphQLSchemaTypes.Exact<{
  feedInput: __GraphQLSchemaTypes.FeedInput;
}>;

export type CreateFeedMutation = {
  __typename?: "Mutation";
  createFeed: { __typename?: "CreateFeedResponse"; feedId: string };
};

export type FavoriteListingsQueryVariables = __GraphQLSchemaTypes.Exact<{
  [key: string]: never;
}>;

export type FavoriteListingsQuery = {
  __typename?: "Query";
  favoriteListings: {
    __typename?: "FavoriteListings";
    listings: Array<{
      __typename?: "Listing";
      id: string;
      description?: string | null;
      disclaimer: string;
      imageCoverUrl: string;
      mlsLogo?: string | null;
      mlsNumber: string;
      originatingSystemName?: string | null;
      previousListPriceCents: any;
      priceCents: any;
      priceChangeTimestamp?: string | null;
      propertyType: __GraphQLSchemaTypes.PropertyType;
      propertySubtype?: string | null;
      bedroomsCount?: number | null;
      bathroomsCount?: number | null;
      sqftTotal?: number | null;
      sqftLot?: number | null;
      showMapLink?: boolean | null;
      status: string;
      thumbnailImageFileNames?: Array<string | null> | null;
      updatedAt: string;
      yearBuilt?: number | null;
      address: {
        __typename?: "ListingAddress";
        number?: string | null;
        street?: string | null;
        unitNumber?: string | null;
        city?: string | null;
        stateOrProvince: string;
        postalCode: string;
        latitude: number;
        longitude: number;
      };
      agent?: {
        __typename?: "ListingAgent";
        email?: string | null;
        mlsId?: string | null;
        name?: string | null;
        phone?: string | null;
        stateLicenseState?: string | null;
        stateLicenseNumber?: string | null;
      } | null;
      brokerage?: {
        __typename?: "Brokerage";
        name?: string | null;
        phone?: string | null;
      } | null;
    } | null>;
  };
};

export type FeedQueryVariables = __GraphQLSchemaTypes.Exact<{
  feedId: __GraphQLSchemaTypes.Scalars["ID"]["input"];
  options?: __GraphQLSchemaTypes.InputMaybe<__GraphQLSchemaTypes.FeedOptions>;
}>;

export type FeedQuery = {
  __typename?: "Query";
  feed: {
    __typename?: "Feed";
    feedType: __GraphQLSchemaTypes.FeedType;
    id: string;
    lastNotificationAtNative?: string | null;
    lastNotificationAtWeb?: string | null;
    subscribedAt?: string | null;
    subscribed: boolean;
    webUserId: string;
    listings: Array<{
      __typename?: "ListingCompact";
      bathroomsCount?: number | null;
      bedroomsCount?: number | null;
      closeDate?: string | null;
      closePriceCents?: any | null;
      daysOnMarket?: number | null;
      id: string;
      listing_url?: string | null;
      mlsNumber: string;
      originatingSystemName: string;
      previousListPriceCents: any;
      priceCents: any;
      priceChangeTimestamp?: string | null;
      rank?: number | null;
      showMapLink?: boolean | null;
      sqftTotal?: number | null;
      status: string;
      propertyType: __GraphQLSchemaTypes.PropertyType;
      thumbnailImageFileNames?: Array<string> | null;
      address: {
        __typename?: "ListingAddress";
        number?: string | null;
        street?: string | null;
        unitNumber?: string | null;
        city?: string | null;
        stateOrProvince: string;
        postalCode: string;
        latitude: number;
        longitude: number;
      };
    } | null>;
    location: {
      __typename?: "FeedLocation";
      latitude: number;
      longitude: number;
      name: string;
      placeId: string;
      stateAbbreviation: string;
      level: __GraphQLSchemaTypes.SearchLevel;
      city?: string | null;
      zipCode?: string | null;
    };
  };
};

export type FeedsQueryVariables = __GraphQLSchemaTypes.Exact<{
  [key: string]: never;
}>;

export type FeedsQuery = {
  __typename?: "Query";
  feeds: Array<{
    __typename?: "FeedBase";
    id: string;
    feedType: __GraphQLSchemaTypes.FeedType;
    lastNotificationAtNative?: string | null;
    lastNotificationAtWeb?: string | null;
    subscribedAt?: string | null;
    subscribed: boolean;
    webUserId: string;
    location: {
      __typename?: "FeedLocation";
      latitude: number;
      longitude: number;
      name: string;
      placeId: string;
      stateAbbreviation: string;
      level: __GraphQLSchemaTypes.SearchLevel;
      city?: string | null;
      zipCode?: string | null;
    };
  } | null>;
};

export type ToggleFavoriteListingMutationVariables =
  __GraphQLSchemaTypes.Exact<{
    listingId: __GraphQLSchemaTypes.Scalars["ID"]["input"];
  }>;

export type ToggleFavoriteListingMutation = {
  __typename?: "Mutation";
  toggleFavoriteListing: {
    __typename?: "ToggleFavoriteListingResponse";
    isFavorite: boolean;
  };
};

export type ToggleFeedSubscribedMutationVariables = __GraphQLSchemaTypes.Exact<{
  feedId: __GraphQLSchemaTypes.Scalars["ID"]["input"];
}>;

export type ToggleFeedSubscribedMutation = {
  __typename?: "Mutation";
  toggleFeedSubscribed: {
    __typename?: "ToggleFeedSubscribedResponse";
    subscribed: boolean;
  };
};

export const ChangeFeedLocationDocument = `
    mutation ChangeFeedLocation($feedId: ID!, $googlePlaceId: String!) {
  changeFeedLocation(feedId: $feedId, googlePlaceId: $googlePlaceId) {
    id
    feedType
  }
}
    `;

export const useChangeFeedLocationMutation = <
  TError = unknown,
  TContext = unknown,
>(
  client: GraphQLClient,
  options?: UseMutationOptions<
    __GraphQLSchemaTypes.ChangeFeedLocationMutation,
    TError,
    __GraphQLSchemaTypes.ChangeFeedLocationMutationVariables,
    TContext
  >,
  headers?: RequestInit["headers"],
) => {
  return useMutation<
    __GraphQLSchemaTypes.ChangeFeedLocationMutation,
    TError,
    __GraphQLSchemaTypes.ChangeFeedLocationMutationVariables,
    TContext
  >(
    ["ChangeFeedLocation"],
    (variables?: __GraphQLSchemaTypes.ChangeFeedLocationMutationVariables) =>
      fetcher<
        __GraphQLSchemaTypes.ChangeFeedLocationMutation,
        __GraphQLSchemaTypes.ChangeFeedLocationMutationVariables
      >(client, ChangeFeedLocationDocument, variables, headers)(),
    options,
  );
};

export const CreateFeedDocument = `
    mutation CreateFeed($feedInput: FeedInput!) {
  createFeed(feedInput: $feedInput) {
    feedId
  }
}
    `;

export const useCreateFeedMutation = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<
    __GraphQLSchemaTypes.CreateFeedMutation,
    TError,
    __GraphQLSchemaTypes.CreateFeedMutationVariables,
    TContext
  >,
  headers?: RequestInit["headers"],
) => {
  return useMutation<
    __GraphQLSchemaTypes.CreateFeedMutation,
    TError,
    __GraphQLSchemaTypes.CreateFeedMutationVariables,
    TContext
  >(
    ["CreateFeed"],
    (variables?: __GraphQLSchemaTypes.CreateFeedMutationVariables) =>
      fetcher<
        __GraphQLSchemaTypes.CreateFeedMutation,
        __GraphQLSchemaTypes.CreateFeedMutationVariables
      >(client, CreateFeedDocument, variables, headers)(),
    options,
  );
};

export const FavoriteListingsDocument = `
    query FavoriteListings {
  favoriteListings {
    listings {
      id
      address {
        number
        street
        unitNumber
        city
        stateOrProvince
        postalCode
        latitude
        longitude
      }
      agent {
        email
        mlsId
        name
        phone
        stateLicenseState
        stateLicenseNumber
      }
      description
      disclaimer
      imageCoverUrl
      mlsLogo
      mlsNumber
      originatingSystemName
      previousListPriceCents
      priceCents
      priceChangeTimestamp
      propertyType
      propertySubtype
      brokerage {
        name
        phone
      }
      bedroomsCount
      bathroomsCount
      sqftTotal
      sqftLot
      showMapLink
      status
      thumbnailImageFileNames
      updatedAt
      yearBuilt
    }
  }
}
    `;

export const useFavoriteListingsQuery = <
  TData = __GraphQLSchemaTypes.FavoriteListingsQuery,
  TError = unknown,
>(
  client: GraphQLClient,
  variables?: __GraphQLSchemaTypes.FavoriteListingsQueryVariables,
  options?: UseQueryOptions<
    __GraphQLSchemaTypes.FavoriteListingsQuery,
    TError,
    TData
  >,
  headers?: RequestInit["headers"],
) => {
  return useQuery<__GraphQLSchemaTypes.FavoriteListingsQuery, TError, TData>(
    variables === undefined
      ? ["FavoriteListings"]
      : ["FavoriteListings", variables],
    fetcher<
      __GraphQLSchemaTypes.FavoriteListingsQuery,
      __GraphQLSchemaTypes.FavoriteListingsQueryVariables
    >(client, FavoriteListingsDocument, variables, headers),
    options,
  );
};

export const FeedDocument = `
    query Feed($feedId: ID!, $options: FeedOptions) {
  feed(feedId: $feedId, options: $options) {
    feedType
    id
    lastNotificationAtNative
    lastNotificationAtWeb
    subscribedAt
    subscribed
    webUserId
    listings {
      bathroomsCount
      bedroomsCount
      closeDate
      closePriceCents
      daysOnMarket
      id
      listing_url
      mlsNumber
      originatingSystemName
      previousListPriceCents
      priceCents
      priceChangeTimestamp
      rank
      showMapLink
      sqftTotal
      status
      propertyType
      thumbnailImageFileNames
      address {
        number
        street
        unitNumber
        city
        stateOrProvince
        postalCode
        latitude
        longitude
      }
    }
    location {
      latitude
      longitude
      name
      placeId
      stateAbbreviation
      level
      city
      zipCode
    }
  }
}
    `;

export const useFeedQuery = <
  TData = __GraphQLSchemaTypes.FeedQuery,
  TError = unknown,
>(
  client: GraphQLClient,
  variables: __GraphQLSchemaTypes.FeedQueryVariables,
  options?: UseQueryOptions<__GraphQLSchemaTypes.FeedQuery, TError, TData>,
  headers?: RequestInit["headers"],
) => {
  return useQuery<__GraphQLSchemaTypes.FeedQuery, TError, TData>(
    ["Feed", variables],
    fetcher<
      __GraphQLSchemaTypes.FeedQuery,
      __GraphQLSchemaTypes.FeedQueryVariables
    >(client, FeedDocument, variables, headers),
    options,
  );
};

export const FeedsDocument = `
    query Feeds {
  feeds {
    id
    feedType
    lastNotificationAtNative
    lastNotificationAtWeb
    subscribedAt
    subscribed
    webUserId
    location {
      latitude
      longitude
      name
      placeId
      stateAbbreviation
      level
      city
      zipCode
    }
  }
}
    `;

export const useFeedsQuery = <
  TData = __GraphQLSchemaTypes.FeedsQuery,
  TError = unknown,
>(
  client: GraphQLClient,
  variables?: __GraphQLSchemaTypes.FeedsQueryVariables,
  options?: UseQueryOptions<__GraphQLSchemaTypes.FeedsQuery, TError, TData>,
  headers?: RequestInit["headers"],
) => {
  return useQuery<__GraphQLSchemaTypes.FeedsQuery, TError, TData>(
    variables === undefined ? ["Feeds"] : ["Feeds", variables],
    fetcher<
      __GraphQLSchemaTypes.FeedsQuery,
      __GraphQLSchemaTypes.FeedsQueryVariables
    >(client, FeedsDocument, variables, headers),
    options,
  );
};

export const ToggleFavoriteListingDocument = `
    mutation ToggleFavoriteListing($listingId: ID!) {
  toggleFavoriteListing(listingId: $listingId) {
    isFavorite
  }
}
    `;

export const useToggleFavoriteListingMutation = <
  TError = unknown,
  TContext = unknown,
>(
  client: GraphQLClient,
  options?: UseMutationOptions<
    __GraphQLSchemaTypes.ToggleFavoriteListingMutation,
    TError,
    __GraphQLSchemaTypes.ToggleFavoriteListingMutationVariables,
    TContext
  >,
  headers?: RequestInit["headers"],
) => {
  return useMutation<
    __GraphQLSchemaTypes.ToggleFavoriteListingMutation,
    TError,
    __GraphQLSchemaTypes.ToggleFavoriteListingMutationVariables,
    TContext
  >(
    ["ToggleFavoriteListing"],
    (variables?: __GraphQLSchemaTypes.ToggleFavoriteListingMutationVariables) =>
      fetcher<
        __GraphQLSchemaTypes.ToggleFavoriteListingMutation,
        __GraphQLSchemaTypes.ToggleFavoriteListingMutationVariables
      >(client, ToggleFavoriteListingDocument, variables, headers)(),
    options,
  );
};

export const ToggleFeedSubscribedDocument = `
    mutation ToggleFeedSubscribed($feedId: ID!) {
  toggleFeedSubscribed(feedId: $feedId) {
    subscribed
  }
}
    `;

export const useToggleFeedSubscribedMutation = <
  TError = unknown,
  TContext = unknown,
>(
  client: GraphQLClient,
  options?: UseMutationOptions<
    __GraphQLSchemaTypes.ToggleFeedSubscribedMutation,
    TError,
    __GraphQLSchemaTypes.ToggleFeedSubscribedMutationVariables,
    TContext
  >,
  headers?: RequestInit["headers"],
) => {
  return useMutation<
    __GraphQLSchemaTypes.ToggleFeedSubscribedMutation,
    TError,
    __GraphQLSchemaTypes.ToggleFeedSubscribedMutationVariables,
    TContext
  >(
    ["ToggleFeedSubscribed"],
    (variables?: __GraphQLSchemaTypes.ToggleFeedSubscribedMutationVariables) =>
      fetcher<
        __GraphQLSchemaTypes.ToggleFeedSubscribedMutation,
        __GraphQLSchemaTypes.ToggleFeedSubscribedMutationVariables
      >(client, ToggleFeedSubscribedDocument, variables, headers)(),
    options,
  );
};
